import { AuthAPI, json, checkStatus } from '@driftt/dapper'
import { APP_URL, DEFAULT_CLIENT_ID } from 'constants/ResourcesConstants'

export const checkEmailIsSSOEnabled = ({ email }) => {
  return AuthAPI
    .post(`/sso/saml/enabled`, { email })
    .then(checkStatus)
    .then(json)
}

export const resolveSsoRedirectUrl = ({ email }) => {
  const payload = { email, postLoginUrl: APP_URL, authClientId: DEFAULT_CLIENT_ID }
  return AuthAPI
    .post(`/sso/saml/login-url`, payload)
    .then(checkStatus)
    .then(json)
}

export const checkOrgIsSSOEnabledForOrg = () => {
  return AuthAPI
    .get(`/sso/saml/settings/enabled`)
    .then(checkStatus)
    .then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/auth/api.js